import $ from 'jquery';
import Api from '../util/Api';
import Popup from '../util/Popup';

$('.popup-form--question').submit(function (e) {
    e.preventDefault();
    const form = $(this);

    Api.post('/api/question/add/', $(this).serializeObject()).then(() => {
        Popup.hide('question');
        Popup.notify('Your question sent successfully');

        form[0].reset();
    });
});
